function Threebox(props) {
    return (
        <div className="flex flex-col lg:flex-row gap-10 items-center justify-center">
            {props.children}
        </div>
    )
}

export default Threebox